import { render, staticRenderFns } from "./RailsHome.vue?vue&type=template&id=0d115b6a&scoped=true&"
import script from "./RailsHome.vue?vue&type=script&lang=js&"
export * from "./RailsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d115b6a",
  null
  
)

export default component.exports